import React, { useEffect, useState } from 'react';
import { translate } from '../../Services/translation';
import { VariantPickerProps } from './types/VariantPicker.Inteface';
import NewDropdown from './NewDropdown';
import { updateSelectedVariant } from '../../Actions/SelectedVariant.action';
import { useDispatch } from 'react-redux';

const VariantPickerDropdown = (props: VariantPickerProps) => {

  const dispatch = useDispatch();

  const [selectedVariant, setSelectedVariant] = useState<string | null>(
    props.selectedVariantId ?? null
  );

  useEffect(() => {
    var persistedVariantSize = props.options.find(x => x.variantId == props.selectedVariantId)?.firstVariantValue;
    dispatch(updateSelectedVariant(persistedVariantSize, props.selectedVariantId))
  }, [])

  const GetOptions = () => {
    return props.options.map((x) => {
      return {
        value: x.variantId,
        label: x.firstVariantValue,
        stockStatus: x.stockStatus,
        articleNumber: x.articleNumber,
        isDisabled: false,
        isBackOrder: props.isBackOrder ?? false,
        inStock: x.inStock,
      };
    });
  };

  const handleButtonClick = () => {
    props.setIsModalOpen();
  };

  const onChange = (event) => {
    let variant = props.options.find((x) => x.variantId == event.value);

    setSelectedVariant(event.value);
    props.setSelectedArticleNumber(variant);

    dispatch(updateSelectedVariant(event.label, event.value))
  };

  return (
    <NewDropdown
      selectorField="value"
      options={GetOptions()}
      onChange={onChange}
      selectedValue={selectedVariant}
      placeholder={
        translate('select.placeholder') + ' ' + props.firstVariant
      }
      onButtonClick={props.setIsModalOpen ? handleButtonClick : null}
      menuPlacement={props.menuPlacement}
    />
  );
};

export default VariantPickerDropdown;
